export default {
  allCostCenters: [],
}
